import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { Button, Col, Popconfirm, Row, Tooltip } from "antd"
import { Color, Font } from "../../../../constants"

type Props = {
    onCancelClicked: () => void
    onSubmitClicked?: () => void
    onDeleteClicked?: () => void
    deleteConfirmMessage?: string | React.ReactNode
    deleteButtonLabel?: string
    deleteDisabled: boolean
    useDeletePopconfirm?: boolean
    additionalButtons?: React.ReactNode
    showDeleteButton?: boolean
    cancelButtonLabel?: string
    cancelDisabled?: boolean
    saveButtonLabel?: string
    confirmSaveText?: Maybe<React.ReactElement<any>>
    saveDisabled?: boolean
    saveDisabledMessage?: Maybe<string>
    saveLoading?: boolean
    deleteLoading?: boolean
}

class DrawerDetailFormFooter extends React.Component<Props> {
    static defaultProps = {
        showDeleteButton: false,
        deleteConfirmMessage: "Do you really want to delete this record?",
        cancelButtonLabel: "Cancel",
        deleteButtonLabel: "Delete",
        useDeletePopconfirm: true,
        saveButtonLabel: "Save",
        confirmSaveText: null,
        deleteDisabled: false,
        saveDisabled: false,
        saveDisabledMessage: null,
        saveLoading: false,
        deleteLoading: false,
    }
    renderSaveButton = () => {
        if (this.props.saveDisabled) {
            return (
                <Tooltip placement="topLeft" title={this.props.saveDisabledMessage}>
                    <Button disabled={true} className="save-btn" type="primary" loading={this.props.saveLoading}>
                        Save
                    </Button>
                </Tooltip>
            )
        }

        if (this.props.confirmSaveText) {
            return (
                <Popconfirm
                    placement="topLeft"
                    arrowPointAtCenter={true}
                    title={this.props.confirmSaveText}
                    onConfirm={this.props.onSubmitClicked}
                    onCancel={() => {}}
                    okText="Yes"
                    cancelText="No">
                    <Button className="save-btn" type="primary" loading={this.props.saveLoading}>
                        Save
                    </Button>
                </Popconfirm>
            )
        } else if (this.props.onSubmitClicked) {
            return (
                <Button
                    className="save-btn"
                    type="primary"
                    onClick={this.props.onSubmitClicked}
                    loading={this.props.saveLoading}>
                    {this.props.saveButtonLabel}
                </Button>
            )
        }
    }
    renderDeleteButton = () => {
        if (this.props.useDeletePopconfirm) {
            return (
                <Popconfirm
                    disabled={this.props.deleteDisabled}
                    title={this.props.deleteConfirmMessage}
                    onConfirm={this.props.onDeleteClicked}
                    onCancel={() => {}}
                    okText="Yes"
                    cancelText="No">
                    <Button
                        type="danger"
                        disabled={this.props.deleteDisabled}
                        loading={this.props.deleteLoading}
                        style={{
                            marginRight: "1.5rem",
                        }}>
                        {this.props.deleteButtonLabel}
                    </Button>
                </Popconfirm>
            )
        }
        return (
            <Button
                type="danger"
                onClick={this.props.onDeleteClicked}
                disabled={this.props.deleteDisabled}
                loading={this.props.deleteLoading}
                style={{
                    marginRight: "1.5rem",
                }}>
                {this.props.deleteButtonLabel}
            </Button>
        )
    }

    render() {
        return (
            <div className="modal-footer-panel">
                <style jsx={true} global={true}>
                    {`
                        .modal-footer-btns-wrapper {
                            float: right;
                            margin-left: 10px;
                        }
                        .modal-footer-btns-wrapper .ant-btn {
                            min-width: 4.75rem;
                        }
                        .modal-footer-btns-wrapper .save-btn span {
                            font-weight: ${Font.Light};
                        }
                        .modal-footer-panel {
                            padding: 1rem;
                            padding-left: 1.5rem;
                            padding-right: 1.5rem;
                            border-top: 1px solid ${Color.antBorder};
                            position: fixed;
                            bottom: 0;
                            width: 100%;
                            background-color: white;
                            z-index: 9999;
                        }
                    `}
                </style>
                <Row>
                    <Col span={12}>
                        {this.props.onDeleteClicked && this.props.showDeleteButton && this.renderDeleteButton()}
                        {this.props.additionalButtons ?? null}
                    </Col>
                    <Col
                        span={12}
                        style={{
                            textAlign: "right",
                        }}>
                        <div className="modal-footer-btns-wrapper">{this.renderSaveButton()}</div>
                        <div className="modal-footer-btns-wrapper">
                            <Button disabled={this.props.cancelDisabled} onClick={this.props.onCancelClicked}>
                                {this.props.cancelButtonLabel}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default DrawerDetailFormFooter
